module.exports = __webpack_public_path__ + "static/media/images-default-1.527e0daf.png";